export const documentation = {
    v1Url: 'https://opay.dev/docs/v1',
}
